import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import { showErrors, showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';
import { utcDateTimeToLocal, formatWeixinDate } from '@/utils/dateTime';
import ListPage from '@/mixins/list-page';
import { getWeixinRefund, handleRefundAudit } from './gql';
import { findAllPeriod } from '../OrderList/gql';
import { RefundsOrderBy } from '@/interfaces/refund';
import AuditDialog from './pages/AuditDialog.vue';
import AuthFilter from '@/mixins/auth-filter';
import { findDealers } from '@/views/DealerList/gql';
import { auditStatusText, auditOptions, auditCodes } from '@/helpers/audit';
import AppSimpleSearchSelector from '@/components/AppSimpleSearchSelector.vue';
import { formatCurrency } from '@/utils/currency';
import { AuditStatus } from '@/interfaces/status';
import { exportRefundsList } from '../RefundList/gql';
import { downloadBase64 } from '@/helpers/base64-to-file';
import { dispatchUpdateIfNewOrders } from '../../store/dispatches';

var RefundList = /*#__PURE__*/function (_mixins) {
  _inherits(RefundList, _mixins);

  var _super = _createSuper(RefundList);

  function RefundList() {
    var _this;

    _classCallCheck(this, RefundList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '订单管理'
    }, {
      text: '线上退款审核'
    }];
    _this.formatCurrency = formatCurrency;
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.formatWeixinDate = formatWeixinDate;
    _this.refunds = [];
    _this.selectedRefund = null;
    _this.selectedOrders = [];
    _this.disabledActions = true;
    _this.options = {
      sortBy: ['auditStatus'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.dealerOptions = [];
    _this.filter = {
      dealerId: {
        id: null,
        label: ''
      },
      orderNumber: null,
      refundNumber: null,
      phone: null,
      auditStatus_EQ: -1
    };
    _this.totalNum = 0;
    _this.loading = false;
    _this.headers = [{
      text: '审核状态',
      value: 'auditStatus',
      width: 120
    }, {
      text: '退款编号',
      value: 'refundNumber'
    }, {
      text: '经销商',
      value: 'order.dealer.realname',
      sortable: false,
      width: 150
    }, {
      text: '订单编号',
      value: 'order.orderNumber',
      width: 200,
      sortable: false
    }, {
      text: '付款时间',
      value: 'order.timeEnd',
      width: 200,
      sortable: false
    }, {
      text: '订单金额',
      value: 'totalPrice',
      width: 120
    }, {
      text: '学生姓名',
      value: 'order.address.realname',
      width: 140,
      sortable: false
    }, {
      text: '支付用户手机号',
      value: 'order.address.phone',
      sortable: false
    }];
    _this.refundPassDialog = {
      show: false,
      text: '你确定要通过审核吗？'
    };
    _this.refundRejectDialog = {
      show: false,
      text: '你确定要拒绝审核吗？'
    };
    _this.refundDetailDialog = {
      show: false,
      title: '详情',
      disable: false,
      confirmText: '通过',
      cancelText: '拒绝'
    };
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.AuditStatusText = auditStatusText;
    _this.auditStatusCode = auditCodes();
    _this.auditStatusOptions = auditOptions();
    _this.confirmDialog = {
      show: false,
      title: '',
      text: ''
    };
    return _this;
  }

  _createClass(RefundList, [{
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getRefunds();
    }
  }, {
    key: "onSelectedOrdersChanged",
    value: function onSelectedOrdersChanged(val) {
      var filteredList = val.filter(function (item) {
        return item.auditStatus === 'PENDING';
      });
      this.disabledActions = !filteredList.length;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.onResize();
      this.restorePage(this.cache);
      this.getRefunds();
      this.getDealerOptions();
    }
  }, {
    key: "getDealerOptions",
    value: function () {
      var _getDealerOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query) {
        var where, take, result, typedError;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                where = query && query.model ? {
                  realname: query.model
                } : null;
                take = query && query.take ? query.take : 20;
                _context.prev = 2;
                _context.next = 5;
                return this.$apollo.query({
                  query: findDealers,
                  variables: {
                    order: null,
                    paging: {
                      skip: 0,
                      take: take
                    },
                    where: where
                  }
                });

              case 5:
                result = _context.sent;

                if (result.data.findDealers) {
                  this.dealerOptions = result.data.findDealers.dealers.map(function (option) {
                    return {
                      id: option.id,
                      label: option.realname
                    };
                  });
                }

                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function getDealerOptions(_x) {
        return _getDealerOptions.apply(this, arguments);
      }

      return getDealerOptions;
    }()
  }, {
    key: "getRefunds",
    value: function () {
      var _getRefunds = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, dealerId, orderNumber, refundNumber, phone, auditStatus_EQ, by, asc, order, paging, where, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, dealerId = _this$filter.dealerId, orderNumber = _this$filter.orderNumber, refundNumber = _this$filter.refundNumber, phone = _this$filter.phone, auditStatus_EQ = _this$filter.auditStatus_EQ;
                by = RefundsOrderBy[sortBy[0] || 'createdAt'];
                asc = sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  dealerId_OF_order: dealerId ? dealerId.id : null,
                  orderNumber_OF_order: orderNumber || null,
                  refundNumber: refundNumber || null,
                  phone_OF_order: phone || null,
                  auditStatus_EQ: this.auditStatusCode[auditStatus_EQ] || null
                };
                _context2.next = 10;
                return this.queryRefundsRequest(order, paging, where);

              case 10:
                result = _context2.sent;

                if (result) {
                  this.refunds = result.refunds;
                  this.totalNum = result.paging.totalCount;
                }

                this.loading = false;
                this.storePage();
                dispatchUpdateIfNewOrders({
                  refundAudit: false
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRefunds() {
        return _getRefunds.apply(this, arguments);
      }

      return getRefunds;
    }()
  }, {
    key: "queryAllPeriod",
    value: function () {
      var _queryAllPeriod = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findAllPeriod
                });

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data.findAllUsedPeriodSettings);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function queryAllPeriod() {
        return _queryAllPeriod.apply(this, arguments);
      }

      return queryAllPeriod;
    }()
  }, {
    key: "queryRefundsRequest",
    value: function () {
      var _queryRefundsRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(order, paging, where) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.$apollo.query({
                  query: getWeixinRefund,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", result.data.findWeixinRefunds);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                typedError = _context4.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function queryRefundsRequest(_x2, _x3, _x4) {
        return _queryRefundsRequest.apply(this, arguments);
      }

      return queryRefundsRequest;
    }()
  }, {
    key: "queryRefundAudit",
    value: function () {
      var _queryRefundAudit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(isApprove, orderIds) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.$apollo.mutate({
                  mutation: handleRefundAudit,
                  variables: {
                    orderIds: orderIds,
                    approve: isApprove
                  }
                });

              case 3:
                result = _context5.sent;
                return _context5.abrupt("return", result);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                typedError = _context5.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function queryRefundAudit(_x5, _x6) {
        return _queryRefundAudit.apply(this, arguments);
      }

      return queryRefundAudit;
    }()
  }, {
    key: "handlePass",
    value: function handlePass(item) {
      this.selectedRefund = item;
      this.refundPassDialog.show = true;
    }
  }, {
    key: "handleReject",
    value: function handleReject(item) {
      this.selectedRefund = item;
      this.refundRejectDialog.show = true;
    }
  }, {
    key: "handleAuditConfirm",
    value: function handleAuditConfirm(isPass) {
      var orderIds = this.selectedOrders.reduce(function (prev, curr) {
        if (curr.auditStatus === AuditStatus.PENDING) {
          prev.push(curr.orderId);
        }

        return prev;
      }, []);
      return isPass ? this.refundPassConfirm(orderIds) : this.refundRejectConfirm(orderIds);
    }
  }, {
    key: "refundPassConfirm",
    value: function () {
      var _refundPassConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(orderIds) {
        var result;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.refundPassDialog.show = false;
                this.refundDetailDialog.show = false;
                _context6.next = 4;
                return this.queryRefundAudit(true, orderIds);

              case 4:
                result = _context6.sent;

                if (result) {
                  this.selectedOrders = [];
                  showNotification({
                    msg: '操作成功',
                    type: SnackType.Success
                  });
                  this.getRefunds();
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function refundPassConfirm(_x7) {
        return _refundPassConfirm.apply(this, arguments);
      }

      return refundPassConfirm;
    }()
  }, {
    key: "refundPassCancel",
    value: function refundPassCancel() {
      this.refundPassDialog.show = false;
    }
  }, {
    key: "refundRejectConfirm",
    value: function () {
      var _refundRejectConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(orderIds) {
        var result;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.refundRejectDialog.show = false;
                this.refundDetailDialog.show = false;
                _context7.next = 4;
                return this.queryRefundAudit(false, orderIds);

              case 4:
                result = _context7.sent;

                if (result) {
                  this.selectedOrders = [];
                  showNotification({
                    msg: '操作成功',
                    type: SnackType.Success
                  });
                  this.getRefunds();
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function refundRejectConfirm(_x8) {
        return _refundRejectConfirm.apply(this, arguments);
      }

      return refundRejectConfirm;
    }()
  }, {
    key: "refundRejectCancel",
    value: function refundRejectCancel() {
      this.refundRejectDialog.show = false;
    }
  }, {
    key: "showAuditDetail",
    value: function showAuditDetail(item) {
      this.selectedRefund = item;
      this.refundDetailDialog.show = true;
    }
  }, {
    key: "auditDetailCancel",
    value: function auditDetailCancel() {
      this.refundDetailDialog.show = false;
    }
  }, {
    key: "filterQuerySubmit",
    value: function filterQuerySubmit() {
      this.getRefunds();
    }
  }, {
    key: "refreshList",
    value: function refreshList() {
      this.filter = {
        dealerId: {
          id: null,
          label: ''
        },
        orderNumber: null,
        refundNumber: null,
        phone: null,
        auditStatus_EQ: -1
      };
      this.getRefunds();
    }
  }, {
    key: "exportHandler",
    value: function () {
      var _exportHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this$options2, sortBy, sortDesc, _this$filter2, dealerId, orderNumber, refundNumber, phone, auditStatus_EQ, by, asc, order, where, result, _result$data$exportRe, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                _this$filter2 = this.filter, dealerId = _this$filter2.dealerId, orderNumber = _this$filter2.orderNumber, refundNumber = _this$filter2.refundNumber, phone = _this$filter2.phone, auditStatus_EQ = _this$filter2.auditStatus_EQ;
                by = RefundsOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  dealerId_OF_order: dealerId ? dealerId.id : null,
                  orderNumber_OF_order: orderNumber || null,
                  refundNumber: refundNumber || null,
                  phone_OF_order: phone || null,
                  auditStatus_EQ: this.auditStatusCode[auditStatus_EQ] || null
                };
                _context8.prev = 8;
                _context8.next = 11;
                return this.$apollo.query({
                  query: exportRefundsList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context8.sent;

                if (result.data) {
                  _result$data$exportRe = result.data.exportRefundsList, fileName = _result$data$exportRe.fileName, contentB64 = _result$data$exportRe.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.loading = false;
                _context8.next = 20;
                break;

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8["catch"](8);
                typedError = _context8.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[8, 16]]);
      }));

      function exportHandler() {
        return _exportHandler.apply(this, arguments);
      }

      return exportHandler;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }]);

  return RefundList;
}(mixins(ListPage, AuthFilter));

__decorate([State(function (state) {
  return state.page.RefundList;
})], RefundList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], RefundList.prototype, "onOptionsChanged", null);

__decorate([Watch('selectedOrders', {
  deep: true,
  immediate: true
})], RefundList.prototype, "onSelectedOrdersChanged", null);

RefundList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSimpleSelector: AppSimpleSelector,
    AppSearchBtn: AppSearchBtn,
    AppTextField: AppTextField,
    AuditDialog: AuditDialog,
    AppSimpleSearchSelector: AppSimpleSearchSelector
  }
})], RefundList);
export default RefundList;